const Territory = require('../../entities/Territory');
const { Age }  = require("../Constants");
const TerritoryNames = require("../Names/TerritoryNames");

class VastTerritory extends Territory {
    constructor(age){
        super(
            age,
            TerritoryNames.VastTerritory,
            "Gain " + VastTerritory.GetYellowCubeCount(age) + " yellow cubes, lose 1 blue cube, and gain " + VastTerritory.GetFoodCount(age) + " food.",
            {}
        )
    }

    static GetYellowCubeCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 3;
            case Age.Age2:
                return 4;
        }
    }

    static GetFoodCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 3;
            case Age.Age2:
                return 4;
        }
    }
}

module.exports = VastTerritory;